import styled from "styled-components";

export const ModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  z-index: 10400;
  width: 100vw;
  height: 100vh;
  background-color: #000;
  opacity: 0.5;
`;

export const ModalWrapper = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  z-index: 10500;
  width: 100%;
  height: 100%;
  overflow-x: hidden;
  overflow-y: auto;
  outline: 0;
`;

export const ModalContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  flex: 1;
`;

export const ModalHeader = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-bottom: 10px;

  @media (max-width: 768px) {
    &.smallPadding {
      margin-right: 16px;
    }
  }
  @media screen and (max-width: 320px) {
    margin-right: 10px;
  }
`;

export const Modal = styled.div`
  display: flex;
  flex-direction: column;
  border-radius: 10px;
  background-color: white;
  z-index: 100;
  padding: 17px 25px 35px 25px;
  margin: 30vh auto 0;
  max-width: 430px;
  min-height: 240px;
  vertical-align: middle;
  p {
    text-align: center;
  }
  @media (max-width: 768px) {
    max-width: 330px;
    &.smallPadding {
      padding: 17px 0px 35px 0px;
    }
  }
  @media (max-width: 540px) {
    min-height: 150px;
    max-width: 250px;
    padding: 17px 20px 25px;
  }
  @media (max-width: 360px) {
    /* max-width: 330px; */
  }
  @media screen and (max-width: 280px) {
    width: 100%;
    padding: 17px 0px 35px 0px;
    border-radius: 0px;
    /* max-width: 250px; */
  }
`;

export const ModalTitle = styled.p`
  color: #1d1f21;
  font-family: "DM Sans";
  font-size: 20px;
  position: relative;
  margin-bottom: 15px;
`;

export const ModalContent = styled.div`
  color: #5b5b5b;
  font-size: 23px;
  font-family: "DM Sans";
  margin-bottom: 23px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: center;
  /* padding: 0 44px; */
  @media (max-width: 540px) {
    font-size: 16px;
  }
  p {
    margin-bottom: 3px;
  }
`;

export const ModalCloseButton = styled.div`
  border: none;
  background-color: inherit;
  cursor: pointer;
`;

export const ModalButton = styled.div`
  display: flex;
  justify-content: center;
  button {
    font-family: "DM Sans";
    font-size: 14px;
    padding: 15px 0;
    border-radius: 5px;
    text-align: center;
  }
`;

export const ModalCancel = styled.button`
  border: solid 2px #1d1f21;
  color: #1d1f21;
  width: 136px;
  margin-right: 10px;
  background-color: white;
  @media screen and (max-width: 320px) {
    width: 115px;
  }
`;

export const ModalConfirm = styled.button`
  background-color: #1d1f21;
  color: white;
  border: none;
  width: 140px;
  @media screen and (max-width: 320px) {
    width: 115px;
  }
`;

export const Button = styled.div`
  text-align: center;
  @media screen and (max-width: 320px) {
    width: 100%;
  }
`;
